
































































































































import { Vue, Prop, Component } from "vue-property-decorator";
import { EducationProtocolShort as IEducationProtocolShort } from "@/api/models/education-protocol-short";
import { Course as ICourse } from "@/api/models/course";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";

@Component({
  components: {
    TableActions,
    CustomTableCol,
    CustomTableItem,
    DeleteMaterialModal
  }
})
export default class EducationProtocolTableItem extends Vue {
  @Prop() protocol!: IEducationProtocolShort;
  @Prop({ default: true }) showRemove!: boolean;
  @Prop({ default: false }) isShowCheckBox!: boolean;
  @Prop({ default: false }) checked!: boolean;
  isRemoving: boolean = false;
  course!: ICourse;
  check: boolean = false;

  data() {
    return {
      course: undefined,
      protocolOwner: undefined
    };
  }

  get screenWidth() {
    return window.innerWidth;
  }

  async removeProtocol() {
    this.isRemoving = true;
    await this.$store.dispatch("educationProtocol/REMOVE", this.protocol.id);
    this.isRemoving = false;
  }

  goToEditPage() {
    this.$router.push({
      name: "educationProtocolEdit",
      params: {
        id: this.protocol.id
      }
    });
  }
}
